import { FocusEvent, useEffect, useState } from 'react';
import { FormikErrors } from 'formik';
import { AttributeFormState } from "@idw-types/state/attribute-form-state";
import { Logger } from "@utils/logger";
import { US_STATE_SELECT_OPTIONS } from "@iddataweb/idw-common-ui/constants";
import { SelectOption } from '@iddataweb/idw-common-ui/types';
import { AXNUISelectInputWithErrorMessage } from '@iddataweb/idw-common-ui/containers';
import { useSelector } from 'react-redux';
import { getLanguageContent } from '@redux/selectors/language-selectors';

type DriversLicenseStateSelectInputProps = {
	title: string;
	attribute: AttributeFormState;
	fieldName: string;
	fieldTouched: boolean;
	fieldError: string;
	fieldIsInvalid: boolean;
	fieldShouldBeHighlighted: boolean;
	setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void> | Promise<FormikErrors<any>>;
	setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
	onBlur: (event: FocusEvent<HTMLInputElement>) => void;
	onSetSubmitValue: (payload: any) => void;
	isSubmitting: boolean;
};

export const DriversLicenseStateSelectInput = (props: DriversLicenseStateSelectInputProps) => {
	const {
		title,
		attribute,
		fieldName,
		fieldTouched,
		fieldError,
		fieldIsInvalid,
		fieldShouldBeHighlighted,
		setFieldValue,
		setFieldTouched,
		onBlur,
		onSetSubmitValue,
		isSubmitting,
	} = props;

    const content = useSelector(getLanguageContent);

	const [selectedOption, setSelectedOption] = useState(null);

	useEffect(() => {
		const option = US_STATE_SELECT_OPTIONS.find(state => state.value === attribute.inputData.driversLicenseState);
		if (option) {
			setSelectedOption(option);
		}
	}, [attribute.inputData.driversLicenseState]);

	const handleChange = async (newValue: SelectOption) => {
		Logger.info("[DriversLicenseStateAttribute] Selected State: ", newValue);
		if (newValue && newValue.value !== "--") {
			const { value } = newValue;
			onSetSubmitValue({ inputData: { driversLicenseState: value } });
			await setFieldValue(fieldName, value);
			setFieldTouched(fieldName, true, true);
		}
	};

	return (
		<AXNUISelectInputWithErrorMessage
			controlId={`attr${attribute.id}-driversLicenseState-input`}
			automationId={`attr${attribute.id}-driversLicenseState-input`}
			ariaLabel={content.validation.driversLicenseState.required}
			isClearable={false}
			isSearchable={true}
			title={title}
			placeholder={attribute.placeholder
				? attribute.placeholder
				: content.validation.driversLicenseState.required}
			selectedOption={selectedOption}
			options={US_STATE_SELECT_OPTIONS}
			onChange={handleChange}
			isDisabled={attribute.isDisabled}
			isPlaceholder={attribute.isPlaceholder}
			isOptional={attribute.optional}
			fieldName={fieldName}
			fieldTouched={fieldTouched}
			fieldError={fieldError}
			fieldIsInvalid={fieldIsInvalid}
			fieldShouldBeHighlighted={fieldShouldBeHighlighted}
			onBlur={onBlur}
			setFieldTouched={setFieldTouched}
			isSubmitting={isSubmitting}
		/>
	);
};